import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/table";
import { Subheading } from "../components/heading";
import { Listbox, ListboxOption } from "../components/listbox-new";
import { Combobox } from "../components/combobox-new2";
import { Field, Label } from "../components/fieldset";
import { Textarea } from "../components/textarea";
import { Button } from "../components/button"; 
import { Loader } from "../components/loader";
import config from "../config.js";
import { Input } from "../components/input";
import { Radio, RadioField, RadioGroup } from '../components/radio'
import { ConfirmDialog } from "../components/ConfirmDialog";
import { PlusIcon } from "@heroicons/react/20/solid";
import InfoPopup from "../components/InfoPopup";

export function TitlePermutationEdit({
  onChange,
  optionsAI = [],
  permutations,
  readOnly = false,
  parentData = {},
}) {
    const initializedOnce = useRef(false);
    const [customEditValue, setCustomEditValue] = useState("");
  const [activeRuleId, setActiveRuleId] = useState(null);
  const [tabs, setTabs] = useState([]);
  const rulesContainerRef = useRef(null);
  const resultsContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const isUserEdit = useRef(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [emphasisList, setEmphasisList] = useState([]);
    
    const [showConfirm, setShowConfirm] = useState(false);
  const [pendingCategory, setPendingCategory] = useState(null);

    // --- START: Code added from TitlePermutation.js for "Choose which apply" functionality ---
    const [defaultRulesList, setDefaultRulesList] = useState([]);
    const [activeRuleSelectTab, setActiveRuleSelectTab] = useState(null);
  const [selectedRules, setSelectedRules] = useState([]);
    const [editingRule, setEditingRule] = useState(null);
    const [editRuleText, setEditRuleText] = useState("");
    const [deletingRule, setDeletingRule] = useState(null);
    const [showAddRuleInput, setShowAddRuleInput] = useState(false);
    const [newRuleText, setNewRuleText] = useState("");
    // --- END: Added code ---

    const getEmphasisOptions = (categoryValue) => {
    const selectedCat = emphasisList.find((cat) => cat.category === categoryValue);
    const emphasisObj = selectedCat?.emphasis ?? {};
    const opts = Object.entries(emphasisObj).map(([key, label]) => ({
      value: label,
      label: key,
    }));
    return opts;
  };
	    const [isDefaultPolicy, setIsDefaultPolicy] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
const [isConfirmDialogOpen, setIsConfirmDialogOpen] 	= useState(false);
	
		
	
	
	
 //Result Reset while change title depth
  useEffect(() => {
    // Clear AI results when title_depth changes
    setTabs((prevTabs) =>
      prevTabs.map((tab) => ({
        ...tab,
        results: [],
        allResults: [],
        ai_rule: [],
        ai_example: [],
        start: 0,
        hasMoreResults: true,
      }))
    );
  }, [parentData.title_depth]);
  // Prepopulate dynamic emphasis options once emphasisList is loaded
  useEffect(() => {
    if (tabs.length && emphasisList.length) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) => ({
          ...tab,
          dynamicEmphasisOpt: getEmphasisOptions(tab.category),
        }))
      );
    }
  }, [emphasisList]);
    // Load default emphasis list from API
  useEffect(() => {
    const defaultEmphasis = async () => {
      try {
        const policy = await fetch(
          `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_default_emphasis`,
          { method: "GET", credentials: "include" }
        );
        const data = await policy.json();
        if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
          window.location.href = `/${config.appPath}`;
        } else if (data.emphasisList && Array.isArray(data.emphasisList)) {
          setEmphasisList(data.emphasisList);
          setCategoryOptions(data.emphasisList.map((item) => item.category));
        }
      } catch (error) {
        console.error("Error fetching emphasis list:", error);
      }
    };
    defaultEmphasis();
  }, []);

    // --- START: useEffect added from TitlePermutation.js to fetch default policies ---
    useEffect(() => {
      const fetchDefaultPolicies = async () => {
        try {
          const res = await fetch(
            `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_default_policy`,
            {
              method: "GET",
              credentials: "include",
            }
          );
          const data = await res.json();

          if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
            window.location.href = `/${config.appPath}`;
          } else if (data.status === true && Array.isArray(data.polityList)) {
            // Convert { label, value } ? { id, text }
            const formatted = data.polityList.map((p, idx) => ({
              id: idx + 1,
              text: p.label,
            }));
            setDefaultRulesList(formatted);
          }
        } catch (err) {
          console.error("Error fetching default policies:", err);
        }
      };

      fetchDefaultPolicies();
    }, []);
    // --- END: Added useEffect ---

	// Tooltip component
  const Tooltip = ({ children, content, show }) => {
    return (
      // CORRECTED: Mouse event handlers are now on this wrapper div
      <div 
        className="relative inline-flex items-center"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
        {show && (
          <div
            className="absolute bottom-full left-1/2 z-20 mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg bg-gray-900 px-3 py-2 text-sm text-white shadow-lg"
            role="tooltip"
          >
            {content}
            {/* Tooltip Arrow */}
            <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1">
              <div className="border-4 border-transparent border-t-gray-900"></div>
            </div>
          </div>
        )}
      </div>
    );
  }; 
	
	  // Function to handle reset to default policies
  const handleResetPolicies = () => { 
    setIsConfirmDialogOpen(true);
  }; 
	
const handleConfirmReset = async () => { 
  // Create independent deep copy of default rules
  const defaultRules = defaultRulesList.map((r) => ({
    id: Date.now() + Math.random(),
    value: r.text,
    isEditing: false,
  }));

  // Update only the active tab's rules in the popup
  setTabs((prevTabs) => {
    const updated = [...prevTabs];
    // IMPORTANT: Use activeRuleSelectTab, not selectedTab, because we are inside the popup
    if (activeRuleSelectTab !== null && activeRuleSelectTab >= 0 && activeRuleSelectTab < updated.length) {
      updated[activeRuleSelectTab] = {
        ...updated[activeRuleSelectTab],
        rules: defaultRules,
        // DON'T change default_policy - keep it as "choose"
        // Clear results when resetting
        results: [],
        allResults: [],
        start: 0,
        hasMoreResults: true,
        ai_rule: [],
        ai_example: [],
        error: "",
      };
    }
    return updated;
  });

  // Close the confirmation dialog
  setIsConfirmDialogOpen(false);
  // Hide the tooltip
  setShowTooltip(false);
  // No need to set isDefaultPolicy, it's calculated dynamically
};
	
	
	
  // Function to cancel reset action
  const handleCancelReset = () => {
    setIsConfirmDialogOpen(false); // Close the dialog without doing anything
	// FIX: Hide the tooltip when the dialog is cancelled
    setShowTooltip(false);
  }; 
	
// Show confirm dialog only if user already has data
const handleCategoryChange = (selectedCategory) => {
  const currentCategory = tabs[0]?.category || null;

  // check if any tab has user input
  const hasUserData = tabs.some(
    (tab) =>
      (tab.emphasis && tab.emphasis !== "") ||
      (Array.isArray(tab.ai_example) && tab.ai_example.length > 0) ||
      (Array.isArray(tab.ai_rule) && tab.ai_rule.length > 0)
  );

  // if changing to a new category that has data � show confirm modal
  if (currentCategory && currentCategory !== selectedCategory && hasUserData) {
    setPendingCategory(selectedCategory);
    setShowConfirm(true);
    return;
  }

  applyCategoryChange(selectedCategory);
};

// Apply category to *all* tabs, not just active
const applyCategoryChange = (selectedCategory) => {
  const categoryObj = emphasisList.find(
    (cat) => cat.category === selectedCategory
  );

  const newEmphasisOpt =
    categoryObj && categoryObj["emphasis"]
      ? Object.entries(categoryObj["emphasis"]).map(([key, label]) => ({
          value: label,
          label: key,
        }))
      : [];

  setTabs((prevTabs) =>
    prevTabs.map((tab) => ({
      ...tab,
      category: selectedCategory,
      dynamicEmphasisOpt: newEmphasisOpt,
      emphasis: "",
      results: [],
      allResults: [],
      start: 0,
      hasMoreResults: true,
      ai_rule: [],
      ai_example: [],
      error: "",
    }))
  );
};


 const handleCategoryChangeOld = (selectedCategory) => {
  setTabs((prevTabs) =>
    prevTabs.map((tab, idx) => {
      if (idx !== selectedTab) return tab;

      // Find the selected category in emphasisList
      const categoryObj = emphasisList.find(
        (cat) => cat.category === selectedCategory
      );

      const newEmphasisOpt =
        categoryObj && categoryObj["emphasis"]
          ? Object.entries(categoryObj["emphasis"]).map(([key, label]) => ({
              value: label,
              label: key,
            }))
          : [];

      return {
        ...tab,
        category: selectedCategory,
        dynamicEmphasisOpt: newEmphasisOpt,
        // Only update emphasis if the current value is not in the new options
        emphasis:"",
        // Keep all other tab data intact
        default_policy: tab.default_policy,
        rules: tab.rules,
        results: [],
        allResults: [],
        start: 0,
        limit: tab.limit,
        hasMoreResults: true,
        ai_rule: [],
        ai_example: [],
        error: tab.error,
      };
    })
  );
};

  const comboboxOptions = [
    ...optionsAI.map((option) => ({
      label: option.ai_key,
      value: `Predefined:${option.ai_instruction}`,
    })),
    { label: "Custom Instructions", value: "custom" },
  ];


 useEffect(() => {
  if (!permutations || Object.keys(permutations).length === 0) return;
  if (!emphasisList || emphasisList.length === 0) return;

  // Only initialize from props once � prevent overwriting user edits
  if (initializedOnce.current && isUserEdit.current) return;

  const initialized = Object.entries(permutations).map(([key, entry]) => {
    const category = entry.category || "";
    const dynamicEmphasisOpt = getEmphasisOptions(category);
    return {
      id: Date.now() + Math.random(),
      title: entry.title || key,
      category,
      emphasis: entry.emphasis || "",
      default_policy:entry.default_policy || "yes",
      dynamicEmphasisOpt,
      rules: entry.rules?.map((val) => ({
        id: Date.now() + Math.random(),
        value: val.includes(":") ? val : `${val}`,
        isEditing: true,
      })) || [{ id: Date.now() + Math.random(), value: "", isEditing: true }],
      results: entry.ai_results || [],
      allResults: entry.ai_results || [],
      start: (entry.ai_results || []).length,
      limit: 2,
      hasMoreResults: true,
      error: "",
      ai_rule: entry.ai_dynamic_rule || "",
      ai_example: entry.ai_dynamic_example || "",
    };
  });

  setTabs(initialized);
  isUserEdit.current = false;
  initializedOnce.current = true; //  don't reinitialize again
}, [permutations, emphasisList]);


  useEffect(() => {
    if (!isUserEdit.current) return;
	onChange(buildPermutationsPayload(tabs));
  }, [tabs, onChange]);

  const validateTab = (currentTab, index) => {
    const hasEmphasis =
      currentTab.emphasis && currentTab.emphasis.trim() !== "";
    const hasAiRule =
      Array.isArray(currentTab.rules) &&
      currentTab.rules.some((rule) => rule.value && rule.value.trim() !== "");

    const updatedTabs = [...tabs];

   /* if (!hasEmphasis && !hasAiRule) {
      updatedTabs[index].error =
        "Please provide either an Emphasis or at least one AI instruction before searching examples.";
      setTabs(updatedTabs);
      return false;
    }*/
    if (!hasEmphasis ) {
      updatedTabs[index].error =
        "Please select an emphasis before searching for examples.";
      setTabs(updatedTabs);
      return false;
    }
    // clear error if valid
    updatedTabs[index].error = "";
    setTabs(updatedTabs);
    return true;
  };

const loadMoreResults = async () => {
  isUserEdit.current = true;
  const updated = [...tabs];
  const currentTab = { ...updated[selectedTab] };

  const start = currentTab.start || 0;
  const limit = currentTab.limit || 2;

  // Set per-tab loader (instead of global loader)
  currentTab.isLoadingMore = true;
  updated[selectedTab] = currentTab;
  setTabs(updated);

      // scroll to bottom immediately so loader is visible
  setTimeout(() => {
    if (resultsContainerRef.current) {
      resultsContainerRef.current.scrollTo({
        top: resultsContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, 100);

  try {
    const response = await fetch(
      `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=search_product_more`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title_depth: parentData.title_depth,
          category: parentData.category,
          brand: parentData.brand,
          impressions: parentData.impressions,
          batch_type: parentData.batch_type,
          sku_limit: limit,
          start: start,
          ai_rule: currentTab.ai_rule || tabs[selectedTab].ai_rule || "",
          ai_example:
            currentTab.ai_example || tabs[selectedTab].ai_example || "",
        }),
      }
    );

    const data = await response.json();

    if (data.status === "success") {
      const moreResults = data.records || [];
      const newStart = start + limit;

      const newTab = {
        ...currentTab,
        results: [...(currentTab.results || []), ...moreResults],
        allResults: [...(currentTab.allResults || []), ...moreResults],
        start: newStart,
        isLoadingMore: false, // turn off loader after success
      };

      const newTabs = [...updated];
      newTabs[selectedTab] = newTab;
      setTabs(newTabs);

      // Update parent
      onChange(buildPermutationsPayload(newTabs));

      // Smooth scroll to bottom after results update
      setTimeout(() => {
        if (resultsContainerRef.current) {
          resultsContainerRef.current.scrollTo({
            top: resultsContainerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 250);
    } else if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
      window.location.href = `/${config.appPath}`;
    }
  } catch (err) {
    console.error("API error (More Results):", err);
  } finally {
    // ensure loader turns off even if request fails
    setTabs((prev) => {
      const copy = [...prev];
      if (copy[selectedTab]) copy[selectedTab].isLoadingMore = false;
      return copy;
    });
  }
};

  const loadMoreResultsOld = async () => {
    isUserEdit.current = true;
    const updated = [...tabs];
    const currentTab = { ...updated[selectedTab] };

    const start = currentTab.start || 0;
    const limit = currentTab.limit || 2;

    setLoading(true);

    try {
      const response = await fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=search_product_more`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            title_depth: parentData.title_depth,
            category: parentData.category,
            brand: parentData.brand,
            impressions: parentData.impressions,
            batch_type: parentData.batch_type,
            sku_limit: limit,
            start: start,
            ai_rule: currentTab.ai_rule || tabs[selectedTab].ai_rule || "",
            ai_example:currentTab.ai_example || tabs[selectedTab].ai_example || "",
          }),
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        const moreResults = data.records || [];
        currentTab.results = [...currentTab.results, ...moreResults];
        currentTab.allResults = [...currentTab.allResults, ...moreResults];
        currentTab.start = start + limit;

        updated[selectedTab] = {
          ...currentTab,
        };
        setTabs(updated);
        onChange(buildPermutationsPayload(updated));
        setTimeout(() => {
  if (resultsContainerRef.current) {
    resultsContainerRef.current.scrollTo({
      top: resultsContainerRef.current.scrollHeight,
      behavior: "smooth",
    });
  }
}, 150);
      } else if (
        data.status === "error" &&
        data.errMsg === "Invalid Loign Data"
      ) {
        window.location.href = `/${config.appPath}`;
      }
    } catch (err) {
      console.error("API error (More Results):", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    const currentTab = tabs[selectedTab];
    if (!validateTab(currentTab, selectedTab)) return;
    isUserEdit.current = true;
    const emphasisValue = currentTab.emphasis;
    const defaultPolicy = currentTab.default_policy;
    const aiInstructions = currentTab.rules
      .filter((rule) => rule.value && rule.value.trim() !== "")
      .map((rule) => {
        return typeof rule.value === "string" &&
          rule.value.startsWith("custom:")
          ? rule.value.slice(7)
          : rule.value;
      });

    setLoading(true);
    try {
      const response = await fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=search_product`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },

          body: JSON.stringify({
            title_depth: parentData.title_depth,
            category: parentData.category,
            brand: parentData.brand,
            impressions: parentData.impressions,
            sku_limit: currentTab.limit,
            batch_type: parentData.batch_type,
            emphasis: emphasisValue,
            default_policy:defaultPolicy,
            ai_instructions: aiInstructions,
          }),
        }
      );

      const data = await response.json();

      if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
        window.location.href = `/${config.appPath}`;
      } else if (data.status === "success") {
        const fullResults = data.records || [];
        const updated = [...tabs];
        if (fullResults.length === 0) {
          updated[selectedTab] = {
            ...updated[selectedTab],
            results: [],
            allResults: [],
            ai_rule: [],
            ai_example: [],
            error: "No products found for the selected product filters.",
          };
          setTabs(updated);
          setLoading(false);
          return;
        }
        updated[selectedTab] = {
          ...updated[selectedTab],
          ai_rule: data.ai_rules || [],
          ai_example: data.ruleExample || [],
          results: fullResults.slice(0, 2),
          allResults: fullResults,
          start: fullResults.length,
          hasMoreResults: fullResults.length === currentTab.limit,
        };
        setTabs(updated);
        onChange(buildPermutationsPayload(updated));
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };

const buildPermutationsPayload = (tabsArr) => {
  const out = {};
  tabsArr.forEach((t, idx) => {
    out[`rule${idx + 1}`] = {
      title: t.title,
      emphasis: t.emphasis,
      default_policy:t.default_policy,
      category: t.category,
      dynamicEmphasisOpt: t.dynamicEmphasisOpt,
      // never send empty rules
      rules: (t.rules || [])
        .map(r => (typeof r.value === 'string' ? r.value.trim() : ''))
        .filter(Boolean),

      // include AI data with the SAME keys you read on init
      ai_results: t.results || [],
      ai_dynamic_rule: Array.isArray(t.ai_rule)
        ? t.ai_rule.filter(Boolean)
        : (t.ai_rule ? [t.ai_rule] : []),
      ai_dynamic_example: Array.isArray(t.ai_example)
        ? t.ai_example.filter(Boolean)
        : (t.ai_example ? [t.ai_example] : []),
    };
  });
  return out;
};

  const handleTabChange = (index, field, value) => {
    isUserEdit.current = true;
    const updated = [...tabs];
    const currentTab = updated[index];

    const previousValue = currentTab[field];
    const isEmphasisChange = field === "emphasis" && previousValue !== value;

    updated[index][field] = value;
    updated[index].error = "";

    if (isEmphasisChange) {
      // Clear AI fields and results on Emphasis change
      updated[index].results = [];
      updated[index].allResults = [];
      updated[index].start = 0;
      updated[index].hasMoreResults = true;
      updated[index].ai_rule = [];
      updated[index].ai_example = [];
    }

    setTabs(updated);
  };

  const handleRuleChange = (tabIndex, ruleId, newValue) => {
    isUserEdit.current = true;
    const updatedTabs = [...tabs];
    const tab = updatedTabs[tabIndex];

    const existingRule = tab.rules.find((rule) => rule.id === ruleId);
    const existingValue = existingRule?.value;

    const isChanged = existingValue !== newValue;

    updatedTabs[tabIndex].rules = tab.rules.map((rule) =>
      rule.id === ruleId ? { ...rule, value: newValue } : rule
    );

    if (isChanged) {
      // Clear all dynamic values and results
      updatedTabs[tabIndex].results = [];
      updatedTabs[tabIndex].allResults = [];
      updatedTabs[tabIndex].start = 0;
      updatedTabs[tabIndex].hasMoreResults = true;
      updatedTabs[tabIndex].ai_rule = [];
      updatedTabs[tabIndex].ai_example = [];
    }

    updatedTabs[tabIndex].error = "";
    setTabs(updatedTabs);
  };

  const addRule = (tabIndex) => {
    if (readOnly) return;
    isUserEdit.current = true;
    const updated = [...tabs];
    updated[tabIndex].rules.push({
      id: Date.now(),
      value: "predefined:",
      isEditing: true,
    });
    setTabs(updated);

    // Scroll to bottom after a slight delay
    setTimeout(() => {
      if (rulesContainerRef.current) {
        rulesContainerRef.current.scrollTop =
          rulesContainerRef.current.scrollHeight;
      }
    }, 0);
  };

  const removeRule = (tabIndex, ruleId) => {
  if (readOnly) return;
  isUserEdit.current = true;

  const updated = [...tabs];
  const tab = updated[tabIndex];

  const ruleToRemove = tab.rules.find((r) => r.id === ruleId);

  // remove the clicked rule only
  updated[tabIndex].rules = tab.rules.filter((rule) => rule.id !== ruleId);

  // determine if the removed rule was a "meaningful" instruction
  const shouldClearAI = (() => {
    if (!ruleToRemove) return false;
    const val = (ruleToRemove.value || "").trim();
    if (!val) return false;              // empty -> not meaningful

    // if there's a colon, check content after it (handles "predefined:" placeholder)
    if (val.includes(":")) {
      const after = val.split(":").slice(1).join(":").trim();
      return after.length > 0;           // clear only if there's content after colon
    }
    // no colon but non-empty -> meaningful (clear)
    return true;
  })();

  if (shouldClearAI) {
    updated[tabIndex].results = [];
    updated[tabIndex].allResults = [];
    updated[tabIndex].start = 0;
    updated[tabIndex].hasMoreResults = true;
    updated[tabIndex].ai_rule = [];
    updated[tabIndex].ai_example = [];
  }

  setTabs(updated);

  // optional: emit to parent immediately so AddTestTitle gets the latest
  // onChange && onChange(buildPermutationsPayload(updated));
};

const addTab = () => {
  if (readOnly) return;
  isUserEdit.current = true;

  const currentCategory = tabs[0]?.category || "";
  const categoryObj = emphasisList.find(
    (cat) => cat.category === currentCategory
  );
  const dynamicEmphasisOpt =
    categoryObj && categoryObj["emphasis"]
      ? Object.entries(categoryObj["emphasis"]).map(([key, label]) => ({
          value: label,
          label: key,
        }))
      : [];

  const newTab = {
    id: Date.now(),
    title: `Permutation ${tabs.length + 1}`,
    category: currentCategory, //inherit common category
    emphasis: "",
    default_policy: "yes",
    dynamicEmphasisOpt,
    rules: [
      {
        id: Date.now() + Math.random(),
        value: "",
        isEditing: true,
      },
    ],
    results: [],
    allResults: [],
    start: 0,
    limit: 2,
    hasMoreResults: true,
    error: "",
    ai_rule: "",
    ai_example: "",
  };

  setTabs((prevTabs) => {
    const updatedTabs = [...prevTabs, newTab];
    setSelectedTab(updatedTabs.length - 1);
    return updatedTabs;
  });
};

  const addTabOld2 = () => {
    if (readOnly) return;
    isUserEdit.current = true;
    const newTab = {
      id: Date.now(),
      title: `Permutation ${tabs.length + 1}`,
      category: "",
      emphasis: "",
      default_policy:"yes",
      dynamicEmphasisOpt: [],
      rules: [
        {
          id: Date.now() + Math.random(),
          value: "",
          isEditing: true,
        },
      ],
      results: [],
      allResults: [],
      start: 0,
      limit: 2,
      hasMoreResults: true,
      error: "",
      ai_rule: "",
      ai_example: "",
    };
    setTabs((prevTabs) => {
      const updatedTabs = [...prevTabs, newTab];
      setSelectedTab(updatedTabs.length - 1); // Select the newly added tab
      return updatedTabs;
    });
  };

  const removeTab = (index) => {
    if (readOnly) return;
    isUserEdit.current = true;
    if (tabs.length === 1) return;
    const updated = tabs.filter((_, i) => i !== index);
    let permIndex = 1;
    const reindexed = updated.map((tab) => {
      if (tab.title.startsWith("Permutation")) {
        const newTitle = `Permutation ${permIndex}`;
        permIndex++;
        return { ...tab, title: newTitle };
      }
      return tab; // leave custom titles untouched
    });

    setTabs(reindexed);
    setSelectedTab((prev) => (prev > 0 ? prev - 1 : 0));
  };



  const tab = tabs[selectedTab];


const isCurrentTabDefaultPolicy = useMemo(() => {
  if (!defaultRulesList.length || !tab?.rules?.length) return false;

  const defaultTexts = defaultRulesList.map(r => r.text).sort();
  const currentTexts = tab.rules.map(r => r.value).filter(Boolean).sort();

  return (
    defaultTexts.length === currentTexts.length &&
    defaultTexts.every((t, i) => t === currentTexts[i])
  );
}, [tab?.rules, defaultRulesList]);

if (tabs.length === 0) return null;

  // --- START: Event handlers added from TitlePermutation.js for the modal ---
  const handleEditRule = (tabIndex, ruleIndex, ruleObj) => {
    if (readOnly) return;
    setEditingRule({ ...ruleObj, tabIndex, ruleIndex });
    setEditRuleText(ruleObj.value || ruleObj.text || "");
  };

  const handleDeleteRule = (tabIndex, ruleIndex) => {
    if (readOnly) return;
    const ruleToDelete = tabs[tabIndex]?.rules?.[ruleIndex];
    if (!ruleToDelete) return;
    setDeletingRule({ ...ruleToDelete, tabIndex, ruleIndex });
  };
  // --- END: Added event handlers ---


	
  return (
    <div className="text-black-800 w-full ">
       {/* Category Selector */}
    <div className="mb-4 grid grid-cols-[max-content_0.5fr_0.5fr] gap-2">
      <div className="m-auto">
      <Subheading>Choose What Fits Your Product</Subheading>
      </div>
      <div>
      <Listbox
        id="category"
        name="category"
        value={tab.category || ""}
        onChange={handleCategoryChange}
        className="w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm"
      >
        {categoryOptions.map((cat) => (
          <ListboxOption key={cat} value={cat}>
            {cat}
          </ListboxOption>
        ))}
      </Listbox>
      </div>
    </div>

      {/* Tabs */}
      <div className="w-full flex overflow-x-auto border border-gray-300 rounded-t-lg">
        {tabs.map((tab, index) => {
          const rawTitle = tab?.title?.trim() || `Permutation ${index + 1}`;
          const truncatedTitle =
            rawTitle.length > 15 ? rawTitle.slice(0, 15) + "..." : rawTitle;

          return (
            <div key={tab.id} className={`relative border-r border-l border-indigo-100 ${
                  selectedTab === index ? "!bg-indigo-100 !border-b-3 !dark:border-indigo-500 !border-b-indigo-600" : ""}`}>
              <Button
                plain
                type="button"
                color={`${selectedTab === index ? "" : ""}`}
                className={`h-full mr-1 ${
                  selectedTab === index
                    ? "!rounded-t-md !rounded-b-none"
                    : "!rounded-none "
                }`}
                onClick={() => setSelectedTab(index)}
                title={rawTitle}
              >
                {truncatedTitle}
              </Button>
              {tabs.length > 1 && !readOnly && (
                <button
                  type="button"
                  onClick={() => removeTab(index)}
                  className="absolute top-0 -right-1 px-1 text-xs text-red-600 hover:text-red-800 cursor-pointer bg-red-200 rounded-lg z-10"
                  disabled={readOnly}
                >
                  ×
                </button>
              )}
            </div>
          );
        })}
        {!readOnly && (
          <Button plain type="button" onClick={addTab} disabled={readOnly}>
            <PlusIcon className="!text-zinc-950"></PlusIcon>
          </Button>
        )}
      </div>

      {/* Main content split into 2 columns */}
      <div className="grid grid-cols-1 md:grid-cols-[1.4fr_3fr] gap-2 shadow-[0_0_15px_rgba(0,0,0,0.12)]">
        {/* LEFT COLUMN */}
        <div className="space-y-8 border-r border-gray-300 p-4">
          {/* Emphasis */}
          {tab.error && (
            <div className="mt-2 text-sm text-red-600 font-medium mb-2">
              {tab.error}
            </div>
          )}
          <section className="grid gap-x-2 sm:grid-cols-1 md:grid-cols-1 mr-8 mb-3">
  <Field>


    {/* Emphasis Selector for normal categories */}
    {tab.category !== "custom" && tab.dynamicEmphasisOpt?.length > 0 && (
      <div className="mb-2">
        <Subheading className="mb-2">
          Title Emphasis
        </Subheading>
        <Listbox
  id="emphasis"
  name="emphasis"
  value={tab.emphasis} // stores the "label" as value
  onChange={(value) => handleTabChange(selectedTab, "emphasis", value)}
  className="w-full rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm"
>
  {tab.dynamicEmphasisOpt.map((opt) => (
    <ListboxOption key={opt.value} value={opt.value}>
      {opt.label} {/* show key */}
    </ListboxOption>
))}
</Listbox>
      </div>
    )}

    {/* Custom Emphasis Input for 'custom' category */}
    {tab.category === "Custom" && (
      <div className="mb-2">
        <Subheading className="mb-2">
           Custom Title Emphasis
        </Subheading>
        <Input
          id="customEmphasis"
          type="text"
          value={tab.emphasis || ""}
          onChange={(e) =>
            handleTabChange(selectedTab, "emphasis", e.target.value)
          }
          placeholder="Enter your custom emphasis here"
          disabled={readOnly}
        />
      </div>
    )}
  </Field>
</section>

<section>
    <Subheading className="mb-2 flex items-center  whitespace-nowrap">Apply default title policies
<InfoPopup
  message={{
    title: "Apply Default Title Policies",
    body: (
      <div className="space-y-4 text-x-sm">

        {/* YES */}
        <div className="flex items-start gap-2">
          <span className="text-blue-500 font-bold text-lg">?</span>
          <div>
            <div className="font-semibold text-gray-900">Yes - Apply Default System Rules</div>
            <div className="text-gray-700 mt-1">
              Uses the platform's built-in title guidelines and automatically runs the Title API.
            </div>
          </div>
        </div>

        {/* NO */}
        <div className="flex items-start gap-2">
          <span className="text-red-500 font-bold text-lg">?</span>
          <div>
            <div className="font-semibold text-gray-900">No - Do Not Apply Rules</div>
            <div className="text-gray-700 mt-1">
              Skips all default rules and runs the Title API using only your selected <strong>Emphasis</strong>.
            </div>
          </div>
        </div>

        {/* CUSTOM */}
        <div className="flex items-start gap-2">
          <span className="text-yellow-500 font-bold text-lg">?</span>
          <div>
            <div className="font-semibold text-gray-900">Choose Which Apply</div>
            <div className="text-gray-700 mt-1">
              Lets you modify or override the default rules and apply your own custom rule set before running the Title API.
            </div>
          </div>
        </div>

      </div>
    )
  }}
/>


</Subheading>
    <RadioGroup name="default_policy"
        value={tab?.default_policy || ""}
        onChange={(val) => {
          isUserEdit.current = true;
          handleTabChange(selectedTab, "default_policy", val);

          if (val === "choose") {
            // Create independent deep copy of default rules
            const chosenRules = defaultRulesList.map((r) => ({
              id: Date.now() + Math.random(),
              value: r.text,
              isEditing: false,
            }));

            // Safe, immutable update for only current tab
            setTabs((prevTabs) => {
              const updated = prevTabs.map((t, i) =>
                i === selectedTab
                  ? { ...t, rules: JSON.parse(JSON.stringify(chosenRules)) }
                  : t
              );
              return updated;
            });
          } else if (val === "yes" || val === "no") {
            // Clear rules for this specific tab safely
            setTabs((prevTabs) => {
              const updated = prevTabs.map((t, i) =>
                i === selectedTab ? { ...t, rules: [] } : t
              );
              return updated;
            });

            // Reset popup state & selected rules
            setSelectedRules([]);
            setActiveRuleSelectTab(null);
          }
        }}
        className="ml-4">
    <RadioField className="flex gap-2 items-center">
      <Radio value="yes" disabled={readOnly} />
      <Label  style={{ pointerEvents: 'none', cursor: 'default' }}>Yes</Label>
    </RadioField>
    <RadioField className="flex gap-2 items-center">
      <Radio value="no" disabled={readOnly} />
      <Label  style={{ pointerEvents: 'none', cursor: 'default' }}>No</Label>
    </RadioField>
    <RadioField className="flex gap-2" >
      <Radio
  value="choose"
  disabled={readOnly}
  onClick={() => {
    if (readOnly) return;
    setActiveRuleSelectTab(selectedTab);

    // Get rules assigned to this permutation (choose rules)
    const chooseRules = tabs[selectedTab]?.rules || [];

    // Preselect them safely for the popup
    setSelectedRules(
      chooseRules
        .map((r) => r.id) // assuming each rule has a unique id
        .filter(Boolean)
    );
  }}
/>
      <Label>Choose which apply</Label>
    </RadioField>
    </RadioGroup>
</section>

          {/* Rules Table */}
          <section className="hidden">
            <Subheading>Add AI Instructions</Subheading>
            <div className="max-h-70 overflow-y-auto" ref={rulesContainerRef}>
              <Table className="mb-2 !overflow-x-visible table-fixed">
                <colgroup>
                  <col className="w-6/8" />
                  <col className="w-2/8" />
                </colgroup>
                <TableHead className="sticky top-0 bg-white z-10">
                  <TableRow>
                    <TableHeader className="border-b-0">
                      Instruction
                    </TableHeader>
                    <TableHeader className="border-b-0">Options</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody className="border-b-0">
                  {tab.rules.map((rule, i) => (
                    <TableRow key={rule.id}>
                      <TableCell className="!px-2 !py-2 border-b-0">
                        {rule.isEditing ? (
                          <div className="flex gap-2">
                            <div
                              className={`${
                                typeof rule.value === "string" &&
                                rule.value.startsWith("custom:")
                                  ? "w-3/8"
                                  : "w-full"
                              } relative`}
                            >
                              <Combobox
                                name={`rule-${rule.id}`}
                                value={
                                  typeof rule.value === "string" &&
                                  rule.value.startsWith("custom:")
                                    ? "custom"
                                    : rule.value || rule.value
                                }
                                onChange={(val) => {
                                  if (readOnly) return; // block changes in view mode
                                  if (val === "") {
                                    handleRuleChange(
                                      selectedTab,
                                      rule.id,
                                      "custom:"
                                    );
                                  } else {
                                    handleRuleChange(
                                      selectedTab,
                                      rule.id,
                                      val === "custom" ? "custom:" : val
                                    );
                                  }
                                }}
                                options={comboboxOptions.map((opt) => ({
                                  ...opt,
                                  disabled:
                                    opt.value !== "custom" &&
                                    tab.rules.some(
                                      (r) =>
                                        r.id !== rule.id &&
                                        r.value === opt.value
                                    ),
                                }))}
                                disabled={readOnly}
                                tabIndex={readOnly ? -1 : 0}
                                onClick={(e) => {
                                  if (readOnly) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }
                                }}
                                className={`w-full rounded-md border border-gray-300 py-1 px-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                                  readOnly
                                    ? "bg-gray-100 cursor-not-allowed"
                                    : ""
                                }`}
                              />
                            </div>
                            <div
                              className={`${
                                typeof rule.value === "string" &&
                                rule.value.startsWith("custom:")
                                  ? "w-5/8 mr-2"
                                  : "w-0"
                              } relative`}
                            >
                              {typeof rule.value === "string" &&
                                rule.value.startsWith("custom:") && (
                                   <Textarea
                                        type="text"
                                        readOnly={readOnly}
                                        value={
                                          rule.id === activeRuleId
                                            ? customEditValue
                                            : rule.value.replace(/^custom:/, "")
                                        }
                                        onFocus={() => {
                                          setActiveRuleId(rule.id);
                                          setCustomEditValue(rule.value.replace(/^custom:/, ""));
                                        }}
                                        onBlur={() => {
                                          handleRuleChange(selectedTab, rule.id, `custom:${customEditValue}`);
                                          setActiveRuleId(null);
                                        }}
                                        onChange={(e) => setCustomEditValue(e.target.value)}
                                        placeholder="Enter custom instruction"
                                        rows={1}
                                        className={`mt-2 ${rule.id === activeRuleId ? "h-24" : ""}`}
                                      />

                                )}
                            </div>
                          </div>
                        ) : (
                          <span>{rule.value || "�"}</span>
                        )}
                      </TableCell>
                      <TableCell className="!px-2 !py-2 border-b-0">
                        <div className="flex gap-2">
                          {!readOnly && tab.rules.length > 1 && (
                            <Button
                              type="button"
                              onClick={() => removeRule(selectedTab, rule.id)}
                              className="mt-2 !h-[28px] !text-[12px] !px-2 !flex !items-center !justify-center !rounded-md"
                            >
                              Remove
                            </Button>
                          )}{" "}
                          {!readOnly && i === tab.rules.length - 1 && (
                            <Button
                              type="button"
                              onClick={() => addRule(selectedTab)}
                              color="white"
                              className="mt-2 !h-[28px] !text-[12px] !px-2 !flex !items-center !justify-center !rounded-md"
                            >
                              Add
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>{" "}
            </div>
          </section>
        </div>

        {/* RIGHT COLUMN */}
        <div className="p-4">
          <Field>
            <div className="flex">
              <Subheading className="mt-auto">Examples</Subheading>
              <div className="text-right ml-auto">
                {tab.results && tab.results.length > 0 && (
                  <Button
                    color="zinc"
                    type="button"
                    onClick={loadMoreResults}
                    disabled={loading || readOnly}
                    className="!text-[12px]"
                  >
                    {loading ? "Loading..." : "More Results"}
                  </Button>
                )}

                {tab.results && tab.results.length === 0 && (
                  <Button
                    color="zinc"
                    type="button"
                    onClick={handleSearch}
                    disabled={loading || readOnly}
                    className="!text-[12px]"
                  >
                    {loading ? "Searching..." : "Show Examples"}
                  </Button>
                )}
            </div>
          </div>
            <div
              className="max-h-77 overflow-y-auto"
              ref={resultsContainerRef}
            >
              <Table className="mb-2 !overflow-x-visible">
                <TableHead className="sticky top-0 bg-white z-10 text-[13px]">
                  <TableRow>
                    <TableHeader>Product Image</TableHeader>
                    <TableHeader>Name</TableHeader>
                  </TableRow>
                </TableHead>


<TableBody>
  {/* CASE 1: show results */}
  {Array.isArray(tab.results) && tab.results.length > 0 ? (
    <>
      {tab.results.map((item, idx) => (
        <TableRow key={idx}>
          <TableCell className="!p-2">
            <img
              src={item.image}
              alt={item.name}
              className="h-[100px] w-[100px] object-cover rounded"
            />
          </TableCell>
          <TableCell className="!p-2 break-words whitespace-normal">
            <div className="font-semibold">Source Title:</div>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-600 hover:text-indigo-800"
            >
              {item.name}
            </a>
            <div className="mt-1">
              <span className="font-semibold">AI Title:</span> {item.aiName}
            </div>
          </TableCell>
        </TableRow>
      ))}

      {/* show "Loading more�" row at bottom */}
      {tab.isLoadingMore && (
  <TableRow>
    <TableCell colSpan={3} className="py-3 text-center">
      <Loader />
      <div className="text-gray-500 text-sm mt-1">Loading more...</div>
    </TableCell>
  </TableRow>
)}
    </>
  ) : loading ? (
    <TableRow>
      <TableCell colSpan={3} className="py-6 text-center">
        <Loader />
      </TableCell>
    </TableRow>
  ) : (
    <TableRow>
      <TableCell colSpan={3} className="py-6 text-center text-gray-500">
        No products found.
      </TableCell>
    </TableRow>
  )}
</TableBody>


              </Table>
            </div>
          </Field>
        </div>
      </div>
<ConfirmDialog
  isOpen={showConfirm}
  title="Confirm to Change Category?"
  message="Changing the category will reset all tabs, emphasis, and results. Do you want to continue?"
  onConfirm={() => {
    applyCategoryChange(pendingCategory);
    setShowConfirm(false);
    setPendingCategory(null);
  }}
  onCancel={() => {
    setShowConfirm(false);
    setPendingCategory(null);
  }}
/>
 
{activeRuleSelectTab !== null && (
  <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl p-8 relative transition-all border border-gray-100">

      {/* Header */}
      <div className="flex items-center justify-between border-b pb-4 mb-5">
        <h2 className="text-xl font-semibold text-gray-800">
          Select Default Title Strategies
        </h2>
        <button
          onClick={() => {
            setActiveRuleSelectTab(null);
            setSelectedRules([]);
          }}
          className="text-gray-400 hover:text-gray-700 text-2xl leading-none"
          disabled={readOnly}
        >
          x
        </button>
      </div>

<div className="max-w-6xl text-right ml-auto mb-2">
<Tooltip 
  content="Your custom rules already match the default policy." 
  show={isCurrentTabDefaultPolicy && showTooltip}
>
  <Button
    color="zinc"
    type="button"
    onClick={handleResetPolicies}
    className={`text-gray-500 border border-gray-300 hover:bg-gray-200 ${
      isCurrentTabDefaultPolicy ? 'cursor-not-allowed opacity-60' : ''
    }`}
    disabled={isCurrentTabDefaultPolicy}
  >
    Reset to Default Policies
  </Button>
</Tooltip>
</div>

      {/* Add New Rule section */}
     <div className="border border-gray-200 rounded-xl p-4 mb-6 bg-gray-50">
  <h3 className="text-sm font-semibold text-gray-700 mb-3">
    Add New Rule
  </h3>
  <div className="flex gap-3">
    <input
      type="text"
      placeholder="Enter new rule"
      value={newRuleText}
      onChange={(e) => setNewRuleText(e.target.value)}
      disabled={readOnly}
      className="flex-1 text-sm border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
    />
    <button
      type="button"
      onClick={() => {
        if (readOnly) return;
        if (newRuleText.trim() !== "") {
          isUserEdit.current = true;
          const newRule = {
            id: Date.now(),
            value: newRuleText.trim(),
            isEditing: false,
          };

          // Update only the active permutation tab�s rules
          setTabs((prevTabs) => {
            const updated = [...prevTabs];
            if (
              activeRuleSelectTab === null ||
              activeRuleSelectTab < 0 ||
              activeRuleSelectTab >= updated.length
            )
              return prevTabs;

            const currentTab = updated[activeRuleSelectTab];
            updated[activeRuleSelectTab] = {
              ...currentTab,
              rules: [...(currentTab.rules || []), newRule],
            };
            return updated;
          });

          // Clear input field
          setNewRuleText("");

          //  Optional smooth scroll to bottom of rule list
          setTimeout(() => {
            const container = document.querySelector(
              ".rules-scroll-container"
            );
            if (container) {
              container.scrollTo({
                top: container.scrollHeight,
                behavior: "smooth",
              });
            }
          }, 150);
        }
      }}
      disabled={readOnly}
      className="px-2 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
    >
      + Add Rule
    </button>
  </div>
</div>


      {/* Rules list */}
      <div className="rules-scroll-container space-y-4 max-h-[60vh] overflow-y-auto pr-2 text-sm">

       {(tabs[activeRuleSelectTab]?.rules || []).map((rule, idx) => (
  <div
    key={rule.id || idx}
    className="flex justify-between items-center border rounded-xl p-2 border-gray-200 hover:bg-gray-50"
  >
    {/* Rule text */}
    <div className="flex-1 text-gray-800">
      {rule.value || rule.text || rule}
    </div>

    {/* Edit / Delete buttons */}
    <div className="flex gap-2 ml-4">
      <button
  type="button"
  className="text-sm text-blue-600 hover:underline disabled:text-gray-400"
  onClick={() => handleEditRule(activeRuleSelectTab, idx, rule)}
  disabled={readOnly}
>
  Edit
</button>

<button
  type="button"
  className="text-sm text-red-600 hover:underline disabled:text-gray-400"
  onClick={() => handleDeleteRule(activeRuleSelectTab, idx)}
  disabled={readOnly}
>
  Delete
</button>

    </div>
  </div>
))}


      </div>
    </div>

   {/* Edit Modal */} 
{editingRule && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[60]">
    <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
      <h3 className="text-lg font-semibold mb-4">Edit Rule</h3>

      <textarea
        value={editRuleText}
        onChange={(e) => setEditRuleText(e.target.value)}
        rows={4}
        className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4 focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
        placeholder="Edit rule text here..."
        autoFocus
      />

      <div className="flex justify-end gap-3">
        <button
          className="px-4 py-2 bg-gray-100 rounded-lg"
          onClick={() => setEditingRule(null)}
        >
          Cancel
        </button>

        <button
          className="px-4 py-2 bg-blue-600 text-white rounded-lg"
          onClick={() => {
            // FIX: Set the flag to true to notify the parent of the change
            isUserEdit.current = true;

            setTabs((prevTabs) => {
              const updated = [...prevTabs];
              const { tabIndex, ruleIndex } = editingRule;
              if (!updated[tabIndex] || !updated[tabIndex].rules) return prevTabs;

              const newRules = [...updated[tabIndex].rules];
              newRules[ruleIndex] = {
                ...newRules[ruleIndex],
                value: editRuleText,
              };

              updated[tabIndex] = { ...updated[tabIndex], rules: newRules };
              return updated;
            });

            setEditingRule(null);
          }}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}



{/* Delete Confirmation Modal */}
{deletingRule && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[60]">
    <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm">
      <h3 className="text-lg font-semibold mb-3 text-gray-800">
        Delete Rule
      </h3>

      <p className="text-gray-600 mb-5">
        Are you sure you want to delete
        <span className="font-medium text-gray-900">
          {" "}"{deletingRule.value || deletingRule.text}"?
        </span>
      </p>

      <div className="flex justify-end gap-3">
        <button
          className="px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 transition"
          onClick={() => setDeletingRule(null)}
        >
          Cancel
        </button>

        <button
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          onClick={() => {
            // FIX: Set the flag to true to notify the parent of the change
            isUserEdit.current = true;

            setTabs((prevTabs) => {
              const updated = [...prevTabs];
              const { tabIndex, ruleIndex } = deletingRule;
              if (!updated[tabIndex] || !updated[tabIndex].rules) return prevTabs;

              const newRules = [...updated[tabIndex].rules];
              newRules.splice(ruleIndex, 1);

              updated[tabIndex] = { ...updated[tabIndex], rules: newRules };
              return updated;
            });

            setDeletingRule(null);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}


  </div>
)}

<ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onConfirm={handleConfirmReset}
        onCancel={handleCancelReset}
        message="Are you sure you want to reset to the default policies? This action will remove all your current rule policies and restore the default settings."
        title = "Confirm Restore Default Policies"
 	  />


    </div>
  );



}